export default "__VITE_ASSET__BCTRiitE__"